<div class="overflow-auto pb-4">
  <!-- EDC Mapping Section -->
  <div class="h-full">
    <div class="rounded-t-lg border bg-aux-gray-light px-6 py-4">
      <div class="flex items-center justify-between">
        <h3 class="text-lg font-semibold text-aux-gray-darkest">EDC Mapping</h3>
        <button
          type="button"
          class="flex items-center space-x-1 text-aux-gray-dark hover:text-aux-gray-darkest"
          aria-label="More options"
        >
          <aux-icon name="DotsVertical" (click)="openDialog()" class="h-5 w-5" />
        </button>
      </div>
    </div>
    <div class="h-[500px] w-full first:rounded-none">
      <ag-grid-angular
        class="ag-theme-aux tabular-nums"
        [domLayout]="'autoHeight'"
        [gridOptions]="gridOptions()"
        [groupDefaultExpanded]="-1"
        [noRowsOverlayComponent]="noRowsUploadComponent"
        [rowData]="edcMappingData()?.mappings || []"
        (gridReady)="onGridReady($event)"
      />
    </div>
  </div>
</div>
